/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Cookie from 'utils/cookies';
import { getMsidFromPath } from 'utils/common';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './OpenInAppBottomWidget.scss';
import PopupOverlay from '../PopupOverlay/PopupOverlay';

class OpenInAppBottomWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deepLinkUrl: undefined,
      showBottomWidget: false,
    };
    this.OpenAppBottomWidgetMod = null;
    this.didPromiseReturn = false;
    this.didBottomWidgetShow = false;
    this.moduleName = 'bottomsheet';
    this.nextShowCookieName = 'bottomWidgetshow';
    this.timerID = false;
    this.pageType = props.pageType;
    this.gaAction = 'sticky_footer_open_toi_app';

    if (!this.pageType) {
      this.gaAction = 'sticky_footer_open_toi_app';
    } else if (this.pageType === 'ARTICLESHOW') {
      this.gaAction = 'articleshow';
    } else if (this.pageType === 'LIVEBLOG') {
      this.gaAction = 'mweb_liveblog';
    } else if (this.pageType === 'Home') {
      this.gaAction = 'mweb_home';
    } else if (this.pageType === 'Listing') {
      this.gaAction = 'mweb_listing';
    } else {
      this.gaAction = 'sticky_footer_open_toi_app';
    }
  }

  removingSpecialCharacters = str => {
    const pattern = new RegExp('[^A-Za-z0-9]', 'g');
    return str.replace(pattern, '');
  };

  generateOneLinkURL = () => {
    const { isEtimes, subSecSeoLocation, WTAConfiguration = {} } = this.props;

    let msid = '';
    let deepLinkTemplate = {};
    const grxId = this.props.grxId || Cookie.get('_grx');

    if (
      typeof window !== 'undefined' &&
      window.location &&
      window.location.href
    ) {
      msid = getMsidFromPath(window.location.href);
    }
    if (
      !msid &&
      this.props.msid &&
      (this.props.pageType === 'ARTICLESHOW' ||
        this.props.pageType === 'LIVEBLOG' ||
        this.props.pageType === 'Videoshow')
    ) {
      msid = this.props.msid;
    }
    if (
      WTAConfiguration &&
      this.props.pageType &&
      typeof this.props.pageType === 'string'
    ) {
      const pageTemplates = this.props.pageType.toLowerCase();
      const { toi = {}, etimes = {} } = WTAConfiguration?.[pageTemplates] || {};
      deepLinkTemplate = isEtimes ? etimes : toi;
    }

    const {
      singularEndPoint = '',
      singularDeeplink = '',
      singularDeeplinkReferrer = '',
      singularUtmSource,
    } =
      deepLinkTemplate || {};

    let afSub1 =
      typeof window === 'object' && window?.grxParams?.storySection
        ? window?.grxParams?.storySection
        : false;
    if (!afSub1 && subSecSeoLocation) {
      afSub1 = subSecSeoLocation;
    }

    /// Replace all placeholders
    const updatedSingularDeeplink = encodeURIComponent(
      (singularDeeplink || '')
        .replace(/{msid}/g, msid || '')
        .replace(/{section}/g, afSub1 || '')
        .replace(/{grxid}/g, grxId || ''),
    );
    const updatedSingularUtmSource = (singularUtmSource || '')
      .replace(/{msid}/g, msid || '')
      .replace(/{section}/g, afSub1 || '')
      .replace(/{grxid}/g, grxId || '');

    const finalDeeplink = `${singularEndPoint}${updatedSingularDeeplink}${singularDeeplinkReferrer}${updatedSingularDeeplink}${updatedSingularUtmSource}`;

    return finalDeeplink;
  };

  handleShow = () => {
    if (this.state.currentWindowUrl !== window?.location?.href) {
      this.setDeepLinkUrl(() => {
        if (
          window &&
          window.TimesApps.PopUpList &&
          window.TimesApps.PopUpList[this.moduleName]
        ) {
          window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
            true,
          );
        }
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'open_in_app_CTA',
          category: 'wtapopup',
          page_template: this.gaAction,
          business_property: 'toi',
          browsing_platform: 'mweb',
          browsing_section: this.props.subSecSeoLocation
            ? this.props.subSecSeoLocation
            : '',
        });
      });
    }
  };

  componentDidMount() {
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(this.moduleName, () => {
            if (
              window.geoinfo &&
              window.geoinfo.CountryCode &&
              window.geoinfo.CountryCode === 'IN' &&
              this.props.condition &&
              (this.props.pageType === 'ARTICLESHOW' ||
                this.props.pageType === 'LIVEBLOG' ||
                this.props.pageType === 'Videoshow')
            ) {
              this.handleShow();
            } else if (
              typeof window === 'object' &&
              window.TimesGDPR &&
              window.TimesGDPR.common.consentModule.gdprCallback &&
              this.props.condition &&
              (this.props.pageType === 'ARTICLESHOW' ||
                this.props.pageType === 'LIVEBLOG' ||
                this.props.pageType === 'Videoshow')
            ) {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (dataObj.userCountry === 'IN') {
                  this.handleShow();
                }
              });
            } else {
              window.TimesApps.PopUpList[
                this.moduleName
              ].callbacks.onShowCallback(false);
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }

  getDummyRefferal = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    return urlParams.get('product') === 'google';
  };

  setDeepLinkUrl = callback => {
    const deepLink = this.generateOneLinkURL();
    this.setState(
      {
        deepLinkUrl: deepLink,
        currentWindowUrl: window?.location?.href,
        showBottomWidget: true,
      },
      callback,
    );
  };

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.throttledOnScroll);
  }

  handleOpenInAppClick = event => {
    event.preventDefault();

    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'open_in_app_CTA',
      category: 'wtapopup',
      label: 'Continue on App',
      page_template: this.gaAction,
      business_property: 'toi',
      browsing_platform: 'mweb',
      browsing_section: this.props.subSecSeoLocation,
    });

    if (this.state.deepLinkUrl) {
      window.location.href = this.state.deepLinkUrl;
    }
  };

  render() {
    const appDeepLinkUrl = this.state.deepLinkUrl;
    if (!appDeepLinkUrl) {
      return null;
    }

    return (
      <PopupOverlay
        position="bottom"
        blackOverlayEnabled
        outSideClickClose
        glPopupWithAd
        closeCallback={() => {
          analyticsWrapper('ga4', {
            event: 'user_click',
            type: 'open_in_app_CTA',
            category: 'wtapopup',
            label: 'Dismiss',
            page_template: this.gaAction,
            business_property: 'toi',
            browsing_platform: 'mweb',
            browsing_section: this.props.subSecSeoLocation,
          });
          this.setState({
            showBottomWidget: false,
          });
        }}
        show={this.state.showBottomWidget}
        mobilewidth100
      >
        <div id="notificationDrawer" className={s.notificationDrawer}>
          <div className={s.notificationDrawerContent}>
            <h3>Continue on app with…</h3>
            <a
              href={appDeepLinkUrl}
              onClick={e => this.handleOpenInAppClick(e, appDeepLinkUrl)}
              data-vars-deeplink-url={appDeepLinkUrl}
            >
              <div className={s.linksWrapper}>
                <div className={s.left}>
                  <strong>Personalised News</strong>
                  <p>Get news tailored just for you!</p>
                </div>
                <div className={s.right}>
                  <i className={s.cupIcon} />
                </div>
              </div>

              <div className={s.linksWrapper}>
                <div className={s.left}>
                  <strong>Notifications</strong>
                  <p>Stay updated, never miss a story!</p>
                </div>
                <div className={s.right}>
                  <i className={s.bellIcon} />
                </div>
              </div>

              <div className={s.ctaListWrap}>
                <span className={s.openapp}>
                  Open App <i className={s.downArrow} />
                </span>
              </div>
            </a>
          </div>
        </div>
      </PopupOverlay>
    );
  }
}

OpenInAppBottomWidget.propTypes = {
  pageType: PropTypes.string.isRequired,
  isEtimes: PropTypes.bool,
  grxId: PropTypes.string,
};

OpenInAppBottomWidget.defaultProps = {
  isEtimes: false,
  grxId: '',
};

export default OpenInAppBottomWidget;
